/*
 Created by qing on 2020/8/24
 Des:
 */
// 公众号appId
export function appId() {
  return 'wx4e50377ebb94b40f'
}

// 公众号原始appId
export function originalAppId() {
  return 'gh_11b09186b8a6'
}

export function MIX_FORM_NAME() {
  return '项目'
}

export function login_bg_image() {
  return '/apaas/form/fetch/image?id=403568830279843841.png'
}
